export const USER_ACCESS_INPUT_CLASS =
  "w-full box-border h-10 min-h-10 border border-[#d3d3d3] rounded px-3 text-[14px] leading-[22px] text-[#222222] bg-white outline-none focus:border-[#00A7A6] focus:shadow-none";

export const USER_ACCESS_SUBCARD_TITLE =
  "zone-settings__card-title text-lg font-semibold";

export const USER_ACCESS_HINT =
  "mt-1 text-[13px] leading-[20px] text-[#5e5e5e] flex items-start gap-2";

export const USER_ACCESS_NOTIFICATION_ROWS = [
  {
    labelKey: "sorting_errors",
    mail: "receiveAnomalyMail",
    sms: "receiveAnomalySms",
    push: "receiveAnomalyPush",
  },
  {
    labelKey: "Downgrade Alert",
    mail: "receiveDowngradeMail",
    sms: "receiveDowngradeSms",
    push: "receiveDowngradePush",
    smsDisabled: true,
    pushDisabled: true,
  },
  {
    labelKey: "Filling level",
    mail: "receiveFillingMail",
    sms: "receiveFillingSms",
    push: "receiveFillingPush",
  },
  {
    labelKey: "Rotation request",
    mail: "receiveRotationMail",
    sms: "receiveRotationSms",
    push: "receiveRotationPush",
    pushDisabled: true,
  },
  {
    labelKey: "Characterizations",
    mail: "recieveCharacterizationMail",
    sms: "recieveCharacterizationSms",
    push: "recieveCharacterizationPush",
    smsDisabled: true,
  },
  {
    labelKey: "Qualicheck",
    mail: "recieveQualicheckMail",
    sms: "recieveQualicheckSms",
    push: "recieveQualicheckPush",
    smsDisabled: true,
  },
];
